"use strict";
exports.__esModule = true;
var flexibleLayout_1 = require("../../../utility/flexibleLayout");
var styled_components_1 = require("styled-components");
var ChartToolContainer = (0, styled_components_1["default"])('div')((0, flexibleLayout_1.flexibleLayoutContainer)({
    justifyContent: 'space-between'
}));
exports["default"] = ChartToolContainer;
